import React, { useEffect, useRef, useState } from "react";
import HeatmapCalendar from "./heatmap-calendar";
import MonthlyPnlTable from "./monthly-pnl-table";
import MetrcisPnlTable from "./metrics-table";
import StatsTable from "./stats-table";
import WeeklyPnlTable from "./weekly-pnl-table";
import DashboardDataTable from "./dashboard-data-table";
import { CheckIcon, XIcon, FilterIcon, RefreshCcwIcon } from "lucide-react";
import StatsDataTable from "./stats-data-table";
import EquityChart from "./equity-chart";

export default function TradeMetrics({
  fileName,
  strategyList,
  allMetricsData,
  filteredTradeData,
  filteredMetricsData,
  filteredMonthlyPNLData,
  filteredWeeklyPNLData,
  filteredDayWisePNLData,
  handleFilterData,
  handleResetFilter,
  selectedStrategy,
  setSelectedStrategy,
}) {
  console.log("Strategy List ----", strategyList);
  const [newCurrentYear, setNewCurrentYear] = useState("2023");
  const [showFilterDropDown, setShowFilterDropdown] = useState(false);
  // const [selectedStrategy, setSelectedStrategy] = useState(null);

  const dropdownRef = useRef(null);

  const handleChangeCurrentYear = (year) => {
    setNewCurrentYear(year);
  };

  const handleShowFilterDropdown = () => {
    setShowFilterDropdown(true);
  };

  const handleCloseFilterDropdown = () => {
    setShowFilterDropdown(false);
  };

  const handleSelectStrategy = (strategy) => {
    setSelectedStrategy(strategy);
    handleCloseFilterDropdown();
    filterDataByStrategy(strategy);
  };

  const tableHeadersMonthlyPNLData = [
    "Strategy",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Total",
  ];

  const tableHeadersWeeklyPNLData = ["Returns by Day", "PNL (₹)"];

  const tableHeadersNewStats = ["Metrcis", "Data"];

  // const handleToggleStrategy = (strategy) => {
  //   setSelectedStrategy((prevState) => ({
  //     ...prevState,
  //     [strategy]: !prevState[strategy], // Toggle the selected state of the strategy
  //   }));
  // };

  const handleToggleStrategy = (strategy) => {
    setSelectedStrategy((prevState) => {
      // Count the number of checkboxes that are checked
      const checkedCount = Object.values(prevState).filter(
        (value) => value
      ).length;

      // If only one checkbox is checked and it's the one being toggled, prevent unchecking it
      if (checkedCount === 1 && prevState[strategy]) {
        return prevState;
      }

      // Toggle the selected state of the strategy
      return {
        ...prevState,
        [strategy]: !prevState[strategy],
      };
    });
  };

  // Add a useEffect hook to listen for changes in selectedStrategy and filter data accordingly
  useEffect(() => {
    const selectedStrategies = Object.keys(selectedStrategy).filter(
      (strategy) => selectedStrategy[strategy]
    );
    filterDataByStrategy(selectedStrategies);
  }, [selectedStrategy]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowFilterDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const filterDataByStrategy = (selectedStrategies) => {
    const currentFileData = allMetricsData.find(
      (item) => item.file_name === fileName
    );

    // Filter data based on each selected strategy
    const newData = selectedStrategies.reduce(
      (filteredData, strategy) => {
        const newMetricsData = currentFileData.metrics_data.filter(
          (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
        );

        const newMonthlyPnlData = currentFileData.monthly_pnl_data.filter(
          (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
        );

        const newDayWisePnlData = currentFileData.day_wise_pnl.filter(
          (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
        );

        const newTradeData = currentFileData.trade_data.filter(
          (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
        );

        // Merge filtered data for each strategy
        return {
          metricsData: [...filteredData.metricsData, ...newMetricsData],
          monthlyPnlData: [
            ...filteredData.monthlyPnlData,
            ...newMonthlyPnlData,
          ],
          dayWisePnlData: [
            ...filteredData.dayWisePnlData,
            ...newDayWisePnlData,
          ],
          tradeData: [...filteredData.tradeData, ...newTradeData],
        };
      },
      {
        metricsData: [],
        monthlyPnlData: [],
        dayWisePnlData: [],
        tradeData: [],
      }
    );

    // Call handleFilterData with the filtered data
    handleFilterData(
      newData.metricsData,
      newData.monthlyPnlData,
      newData.dayWisePnlData,
      newData.tradeData
    );
  };

  return (
    <>
      <div className="flex items-center justify-between space-x-4 mt-4">
        <div className="flex">
          <p className="text-lg font-semibold text-white">
            Trade Metrics for
            <span className="ml-2 text-lg font-semibold text-[#07F2C7]">
              ({fileName})
            </span>
          </p>
        </div>
        <div ref={dropdownRef} className="relative flex  space-x-6">
          <div
            onClick={handleShowFilterDropdown}
            className={` cursor-pointer flex items-center font-semibold text-white space-x-2 bg-zinc-800 px-4 py-2 rounded-md `}
          >
            Filter Metrics
            <FilterIcon className="ml-2 h-4 w-4 text-white" />
          </div>
          <div
            onClick={() => handleResetFilter(fileName, setSelectedStrategy)}
            className={` cursor-pointer flex items-center font-semibold text-white space-x-2 bg-zinc-800 px-4 py-2 rounded-md `}
          >
            Reset Filter
            <RefreshCcwIcon className="ml-2 h-4 w-4 text-white" />
          </div>

          {strategyList !== null && showFilterDropDown === true && (
            <div className="z-10 absolute top-16 -left-8 bg-gray-800  p-1 rounded-sm">
              <div className="flex  flex-col space-y-1 h-full p-2">
                {/* {strategyList.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleSelectStrategy(item)}
                    className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md"
                  >
                    {item}
                  </div>
                ))} */}
                {strategyList.map((strategy, index) => (
                  <div key={index} className="flex items-center">
                    <input
                      type="checkbox"
                      id={strategy}
                      checked={selectedStrategy[strategy]}
                      onChange={() => handleToggleStrategy(strategy)}
                      className="mr-2"
                    />
                    <label htmlFor={strategy} className="text-white">
                      {strategy}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className=" flex space-x-4">
            <button
              onClick={() => handleChangeCurrentYear("2022")}
              className={`${
                newCurrentYear === "2022" ? "bg-[#07F2c7]/30" : "bg-gray-800/80"
              } flex items-center space-x-2  px-4 py-1.5 rounded-md`}
            >
              <span className="text-white text-sm font-semibold">2022</span>
            </button>
            <button
              onClick={() => handleChangeCurrentYear("2023")}
              className={`${
                newCurrentYear === "2023" ? "bg-[#07F2c7]/30" : "bg-gray-800/80"
              } flex items-center space-x-2  px-4 py-1.5 rounded-md`}
            >
              <span className="text-white text-sm font-semibold">2023</span>
            </button>
            <button
              onClick={() => handleChangeCurrentYear("2024")}
              className={`${
                newCurrentYear === "2024" ? "bg-[#07F2c7]/30" : "bg-gray-800/80"
              } flex items-center space-x-2  px-4 py-1.5 rounded-md`}
            >
              <span className="text-white text-sm font-semibold">2024</span>
            </button>
          </div>
        </div>
      </div>

      <div className="flex h-full flex-col relative  w-full ">
        <div className="flex justify-between items-center  w-full  py-4">
          <div>
            {filteredTradeData.length > 0 ? (
              <EquityChart data={filteredTradeData} />
            ) : null}
          </div>

          <div className="w-full pl-[30px]">
            {/* <HeatmapCalendar /> */}
            <div className="flex  text-white text-lg font-medium">Day Wise PNL</div>
            <HeatmapCalendar
              tradeData={filteredDayWisePNLData}
              newCurrentYear={newCurrentYear}
            />
          </div>
        </div>

        <div className="flex w-full pt-2 pb-6">
          <div className="grid grid-cols-12 gap-x-4 gap-y-2 w-full">
            <div className="col-span-12">
              <MetrcisPnlTable
                fileName={fileName}
                selectedStrategy={selectedStrategy}
                rows={filteredMetricsData}
              />
            </div>

            <div className="col-span-12">
              <MonthlyPnlTable
                headers={tableHeadersMonthlyPNLData}
                rows={filteredMonthlyPNLData}
              />
            </div>

            <div className="col-span-3">
              <WeeklyPnlTable
                headers={tableHeadersWeeklyPNLData}
                rows={filteredWeeklyPNLData}
              />
            </div>
            <div className="col-span-3">
              <StatsDataTable
                headers={tableHeadersNewStats}
                metricsData={filteredMetricsData}
                tradeData={filteredDayWisePNLData}
                selectedStrategy={selectedStrategy}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// const filterDataByStrategy = (strategy) => {
//   const currentFileData = allMetricsData.find(
//     (item) => item.file_name === fileName
//   );

//   const newMetricsData = currentFileData.metrics_data.filter(
//     (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
//   );

//   const newMonthlyPnlData = currentFileData.monthly_pnl_data.filter(
//     (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
//   );

//   const newDayWisePnlData = currentFileData.day_wise_pnl.filter(
//     (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
//   );

//   const newTradeData = currentFileData.trade_data.filter(
//     (item) => item.strategy.toLowerCase() === strategy.toLowerCase()
//   );

//   // console.log("New Monthly pnl data",newMonthlyPnlData)

//   handleFilterData(
//     newMetricsData,
//     newMonthlyPnlData,
//     newDayWisePnlData,
//     newTradeData
//   );
// };
